import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { H1 } from 'components/common/Text/Text'
import Button from 'components/common/Button/Button'
import { LazyP } from 'components/common/LazyHtml'

const BOTAccessYourAppointmentInfo = ({
  title,
  content,
  createAccountActionHandler,
  makeAnAppointmentOnClickHandler
}) =>
  <Wrapper>
    <Title data-at-myappointments-header headline>{ title }</Title>
    <Content content={ content } />
    <Button data-at-myappointments-createaccount full="mobile" stacked="mobile" onClick={ createAccountActionHandler }>
      Create account with email
    </Button>
    <Button data-at-myappointments-makeanappointment full="mobile" stacked="mobile" secondary onClick={ makeAnAppointmentOnClickHandler }>
      Request appointment
    </Button>
  </Wrapper>

BOTAccessYourAppointmentInfo.propTypes = {
  content: PropTypes.string,
  createAccountActionHandler: PropTypes.func,
  makeAnAppointmentOnClickHandler: PropTypes.func,
  title: PropTypes.string
}

export default BOTAccessYourAppointmentInfo

const Wrapper = styled.div`
  ${Media.desktop`
    display: inline-block;
    text-align: left;
  `}
  ${Mixin.responsive('padding', '0 0 140px', '31px 16px 100px')}
`

const Title = styled(H1)`
  ${Media.mobile`
    font-size: 30px;
    line-height: 43px;
  `}
  ${Mixin.responsive('margin', '0 0 8px', '0 0')}
`

const Content = styled(LazyP)`
  margin: 0 0 20px;
  line-height: 19px;
`
